import script from "./SignInDetailsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInDetailsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInDetailsPage.vue?vue&type=style&index=0&id=472b4285&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-472b4285"]])

export default __exports__